import axios from '@axios'

const PREFIX = '/grupo-empresarial'

export default {

  getGruposEmpresariais(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getGruposEmpresariaisResumidos(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  getGrupoEmpresarial(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateGrupoEmpresarial(id, grupoEmpresarial) {
    return axios.put(`${PREFIX}/${id}`, grupoEmpresarial)
  },

  createGrupoEmpresarial(grupoEmpresarial) {
    return axios.post(`${PREFIX}/add`, grupoEmpresarial)
  },

  deleteGrupoEmpresarial(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },
}
